import { configureStore } from "@reduxjs/toolkit";
// import userProfileReducer from "./userProfile";  // Import your userProfile reducer

const store = configureStore({
  reducer: {
    // userProfile: userProfileReducer,  // Add your reducer here
  },
});

export default store; // Export the store
